import { useQuery } from '@tanstack/react-query';
import { HierarchyType } from 'pages/admin/demand/planning/components/tabs/planningByLevel/components/mainHierarchyFilter/types/hierarchies.type';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import api from 'services/api/api';

import { buildFiltersPayload } from '../../../../planningByLevel/utils/planningByLevelUtils';

export const QUERY_KEYS_PLANNING = {
	planningFilterConfiguration: 'planningFilterConfiguration',
	byType: (
		cycleId: number,
		email: string,
		forecastType: string,
		companyAreaId?: number
	) => [
		QUERY_KEYS_PLANNING.planningFilterConfiguration,
		cycleId || '',
		email || '',
		forecastType || '',
		companyAreaId || '',
	],
	byId: (id: number) => [QUERY_KEYS_PLANNING.planningFilterConfiguration, id],
};

export interface IPlanningFilterConfigurationSearchResult {
	id: number;
	user_id: number;
	company_id: number;
	company_area_id: number | null;
	cycle_id: number;

	has_product: boolean;
	has_model: boolean;
	has_subfamily: boolean;
	has_family: boolean;
	has_market: boolean;
	has_sales_channel: boolean;
	has_sales_force: boolean;
	has_sales_zone: boolean;
	has_seller: boolean;
	has_customer: boolean;
	has_customer_group: boolean;

	planning_type: PlanningTypes;
	main_filter: HierarchyType;
	is_default: boolean;
}
export function usePlanningFilterConfigurationSearch(
	cycleId: number,
	email: string,
	planningType: PlanningTypes,
	companyAreaId?: number | undefined
) {
	return useQuery({
		queryKey: QUERY_KEYS_PLANNING.byType(
			cycleId,
			email,
			planningType,
			companyAreaId
		),
		queryFn: async () => {
			const params = buildFiltersPayload({
				cycleId,
				companyAreaId,
				planningType,
			});

			const response =
				await api.get<IPlanningFilterConfigurationSearchResult>(
					'/planning-filter-configuration',
					{ params }
				);
			return response.data;
		},
		enabled: !!(cycleId && planningType),
		refetchOnMount: false,
		refetchOnWindowFocus: false,
	});
}
